import apiClient from "../api/client";

import { landing } from "../constants/actionTypes";

const CITY_STATE_ZIP_COUNTRIES = ["us", "ca", "au", "fr", "ir", "gb"];

export const actions = {
  getCityStateZip(cityStateZip) {
    return dispatch => {
      if (!cityStateZip || !cityStateZip.trim()) {
        // Nothing typed: the server has nothing to match (it answers [] for input under 2 characters),
        // so skip the request and clear the list instead of leaving the previous suggestions on screen.
        dispatch({
          type: landing.GET_CITY_STATE,
          payload: []
        });
        return;
      }

      apiClient({
        method: "get",
        responseType: "json",
        url: "/members/json-api/google-places/autocomplete",
        params: { input: cityStateZip, countries: CITY_STATE_ZIP_COUNTRIES },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(res => {
          dispatch({
            type: landing.GET_CITY_STATE,
            payload: res.data
          });
        })
        .catch(() => {
          dispatch({
            type: landing.GET_CITY_STATE_FAIL,
            payload: true
          });
        });
    };
  },

  getCountries() {
    return dispatch => {
      dispatch(this.setLoading("page", true));
      apiClient({
        method: "get",
        responseType: "json",
        url: "/members/json-api/public/heritages",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      })
        .then(res => {
          dispatch({
            type: landing.GET_COUNTRIES,
            payload: res.data
          });
        })
        .catch(() => {
          dispatch({
            type: landing.GET_COUNTRIES_FAIL,
            payload: true
          });
        });
    };
  },

  getPractices(professionsId) {
    return dispatch => {
      dispatch(this.setLoading("page", true));
      apiClient({
        method: "post",
        responseType: "json",
        url: "/members/json-api/public/practices",
        data: JSON.stringify({ profession_id: professionsId })
      })
        .then(res => {
          dispatch({
            type: landing.GET_PRACTICES,
            payload: res.data
          });
        })
        .catch(() => {
          dispatch({
            type: landing.GET_PRACTICES_FAIL,
            payload: true
          });
        });
    };
  },

  getProfessions() {
    return dispatch => {
      dispatch(this.setLoading("page", true));
      apiClient({
        method: "get",
        responseType: "json",
        url: "/members/json-api/public/professions",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      })
        .then(res => {
          dispatch({
            type: landing.GET_PROFESSIONS,
            payload: res.data
          });

          const findLawyer = res.data.find(item => item.title === "Lawyers");

          if (findLawyer) {
            dispatch(this.getPractices(findLawyer.profession_id));
          }
        })
        .catch(() => {
          dispatch({
            type: landing.GET_PROFESSIONS_FAIL
          });
        });
    };
  },

  setLoading(section, isLoading) {
    return {
      type: landing.SET_LOADING,
      payload: { section, isLoading }
    };
  }
};
